import { Link } from './link.interface';
import { PharmacySearchConfig } from './pharmacy-search-config.interface';

export interface CMSConfig {
  links: Link[];
  commonConfig: Record<string, string>;
  pharmacySearchConfig: PharmacySearchConfig | null;
  clientSpecificConfig: ClientConfigurations;
}

export interface ClientConfigurations {
  clientBannerMessage: string;
  hideOutOfNetwork: boolean;
  disableDigitalIDCards: boolean;
  enableAutoChargeShip: boolean;
  suppressMailOrderFeatures: boolean;
  hideDrugPricingTab: boolean;
  enableBannerMessage: {
    commonHeader: boolean;
    benefitScreen: boolean;
    mailOrderScreen: boolean;
    orderCheckoutScreen: boolean;
  }
  enablePMartForm: boolean; // Enable P-mart form for Benecard clients. //TODO: Remove during Benecard cleanup
}

export enum CMS_CONFIG_KEYS_ENUM {
  DEMO_CLIENT = 'DEMO_CLIENT',
  HIDE_OUT_OF_NETWORK_PHARMACIES = 'HIDE_OUT_OF_NETWORK_PHARMACIES',
  DISABLE_TERMED_USER_AFTER = 'DISABLE_TERMED_USER_AFTER',
  BENECARD_CLIENTS_TO_ENABLE_PMART_FORM = 'BENECARD_CLIENTS_TO_ENABLE_PMART_FORM',
  DISABLE_DIGITAL_ID_CARDS = 'DISABLE_DIGITAL_ID_CARDS',
  ENABLE_AUTO_REFILL_CHARGE_SHIP = 'ENABLE_AUTO_REFILL_CHARGE_SHIP',
  SUPPRESS_MAIL_ORDER_FOR_CLIENTS = 'SUPPRESS_MAIL_ORDER_FOR_CLIENTS',
  ENABLE_BENEFIT_BANNER_MESSAGE = "ENABLE_BENEFIT_BANNER_MESSAGE",
  ENABLE_COMMON_HEADER_BANNER_MESSAGE = "ENABLE_COMMON_HEADER_BANNER_MESSAGE",
  ENABLE_MAIL_ORDERS_BANNER_MESSAGE = "ENABLE_MAIL_ORDERS_BANNER_MESSAGE",
  ENABLE_ORDER_CHECKOUT_BANNER_MESSAGE = "ENABLE_ORDER_CHECKOUT_BANNER_MESSAGE",
  DISABLE_DRUG_PRICING = "DISABLE_DRUG_PRICING"
}
